import React from "react";

function Search({ searchQuery, onSearchChange }) {
  return (
    <div className="flex justify-center mb-6">
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search..."
        className="w-full max-w-md px-4 py-2 mb-2 border-1 border-gray-300 rounded-xl bg-white text-gray-900 
                   focus:outline-none
                   transition-colors duration-300"
      />
    </div>
  );
}

export default Search;
